/**
 * Functionality for basic modal window. Note you trigger any anchor tag
 * to open in a modal by attaching the `data-modal` attribute.
 * The anchor's href will be used as an iframe src.
 * For opening webforms in a modal, you should not use this component. Instead,
 * use the Drupal core modal.
 *
 * @author Todd Miller <todd.miller@tricomb2b.com>
 */

(function ($) {
  'use strict';

  let $modals;
  let $modalIds;

  Drupal.behaviors.initializeModalWindows = {
    attach: (context) => {
      if (context === document) initialize();
    },
  };

  /**
   * Just strip the modals from the DOM.
   */
  function handleModalClose() {
    $('.modal-wrapper').remove();
  }

  /**
   * Hide all modals on page and turn off relevant click handlers.
   */
  function handleModalIdClose() {
    $('.modal-wrapper').removeClass('is-active');
    $('.modal-wrapper .close').off('click', handleModalIdClose);
  }

  /**
   * Open the modal with the given id, attaching event handlers as needed.
   */
  function handleModalIdOpen(e) {
    e.preventDefault();

    const id = $(e.currentTarget).data('modal-id');
    const $modal = $(`#${id}`);

    $modal.addClass('is-active');
    $('.modal-wrapper .close').on('click', handleModalIdClose);
  }

  /**
   * Set up the markup for a new modal element and attach it to the DOM.
   */
  function handleModalOpen(e) {
    e.preventDefault();

    const src = $(e.currentTarget).attr('href');
    const $wrapper = $('<div class="modal-wrapper"></div>"');
    const $close = $('<div class="close"></div>');
    const $inner = $('<div class="inner"></div>');
    const $overlay = $('<div class="overlay"></div>');
    const $iframe = $(`<iframe src="${src}" allowfullscreen></iframe>`);

    $inner.append($close).append($iframe);
    $wrapper.append($overlay).append($inner);

    $('body').append($wrapper).fadeIn('fast');
    $('.modal-wrapper .close').on('click', handleModalClose);
  }

  /**
   * Cache elements, attach event handlers.
   */
  function initialize() {
    $modals = $('[data-modal]');
    $modalIds = $('[data-modal-id]');

    if ($modals.length) $modals.on('click', handleModalOpen);

    if ($modalIds.length) $modalIds.on('click', handleModalIdOpen);
  }
})(jQuery);
